import { useState } from "react";

export const AudiencePicker = ({ members, value, onChange, onInvite, testidPrefix = "aud" }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const toggle = (uid) => onChange(value.includes(uid) ? value.filter((x) => x !== uid) : [...value, uid]);

  const invite = async () => {
    const e = email.trim();
    if (!e) return;
    setBusy(true);
    try {
      const u = await onInvite(name.trim(), e);
      if (u?.user_id && !value.includes(u.user_id)) onChange([...value, u.user_id]);
      setName("");
      setEmail("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-3" data-testid={`${testidPrefix}-audience-picker`}>
      <div className="max-h-52 overflow-auto border border-[#24272B]">
        {members.length === 0 && <div className="t-cap text-muted-s p-3">No members yet. Invite someone below.</div>}
        {members.map((m) => (
          <label key={m.user_id} className="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#141619] border-b border-[#1a1c1f]">
            <input type="checkbox" checked={value.includes(m.user_id)} onChange={() => toggle(m.user_id)} data-testid={`${testidPrefix}-aud-${m.user_id}`} />
            <span className="t-small text-bone">{m.name || m.email}</span>
            <span className="t-cap text-muted-s ml-auto">{m.email}</span>
          </label>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <input className="input-solera max-w-[160px]" placeholder="New person name" value={name} onChange={(e) => setName(e.target.value)} data-testid={`${testidPrefix}-invite-name`} />
        <input className="input-solera max-w-[210px]" type="email" placeholder="email@domain.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid={`${testidPrefix}-invite-email`} />
        <button type="button" className="btn-ghost" disabled={busy || !email.trim()} onClick={invite} data-testid={`${testidPrefix}-invite-btn`}>Invite to circle</button>
      </div>
      <p className="t-cap text-muted-s">{value.length} member{value.length === 1 ? "" : "s"} can see this. Inviting a new person creates their Solera account and emails them a welcome.</p>
    </div>
  );
};
